import React, { createContext, useContext, useState } from "react";

/**
 * iter389 — Audience Context for personalised landing-page narrative.
 *
 * Three personas (Patient / Doctor / Clinic) drive different copy, demo
 * variants, and pricing emphasis across the post-hero sections. Defaults to
 * "patient" — the largest segment of the funnel.
 */
const AudienceContext = createContext({
  audience: "patient",
  setAudience: () => {},
});

export const AUDIENCES = ["patient", "doctor", "clinic"];

export function AudienceProvider({ children }) {
  const [audience, setAudience] = useState("patient");
  return (
    <AudienceContext.Provider value={{ audience, setAudience }}>
      {children}
    </AudienceContext.Provider>
  );
}

export function useAudience() {
  return useContext(AudienceContext);
}
